export default __webpack_public_path__ + "static/media/react.410caf3a.png";